import React from "react";
import Top5ProducerExporterField from "./Top5ProducerExporterField";
import { thisBaseURL } from "../../utils/helper.js";

function Top5ProducersExporters({foodAnswers, foodName}){
	let defaultSlug = foodAnswers.answerKeyValues["food_slug"];
	let top5Producers = foodAnswers.answerKeyValues['top_5_producing_countries'];
	let top5ProducerArr = [];
	if(top5Producers){
		try {
			top5ProducerArr = JSON.parse(top5Producers);
		} catch (err) {
			console.log("Top5ProducersExporters :top5Producers: " +err);
		}
	}
	let top5ProducerSourceRef = foodAnswers.answerKeyValues['top_5_producing_countries_sources'];
	let top5ProducerYear = foodAnswers.answerKeyValues['top_5_producing_countries_year'];
	let top5ProducerNotes = foodAnswers.answerKeyValues['top_5_producing_countries_notes'];
	let top5ProducerUnit = foodAnswers.answerKeyValues['top_5_producing_countries_unit'] || "Metric Tons";
	
	
	let top5Exporters = foodAnswers.answerKeyValues['top_5_exporting_countries'];
	let top5ExporterArr = [];
	if(top5Exporters){
		try {
			top5ExporterArr = JSON.parse(top5Exporters);
		} catch (err) {
			console.log("Top5ProducersExporters :top5Exporters: " +err);
		}
	}
	let top5ExporterSourceRef = foodAnswers.answerKeyValues['top_5_exporting_countries_sources'];
	let top5ExporterYear = foodAnswers.answerKeyValues['top_5_exporting_countries_year'];
	let top5ExporterNotes = foodAnswers.answerKeyValues['top_5_exporting_countries_notes'];
	let top5ExporterUnit = foodAnswers.answerKeyValues['top_5_exporting_countries_unit'] || "Metric Tons";
	
	return(<div className="question-grouping">
				<div className="clearfix" style={{marginBottom: "20px"}}>
					<h3>
						Top 5 Producing Countries of {foodName}
						{top5ProducerYear > 0 ? 
						<small>&nbsp;({top5ProducerYear})</small>
						: ""}
						{top5ProducerSourceRef && top5ProducerSourceRef > 0 ? 
						<small className="superscript"><a href={thisBaseURL +"/foods/" +defaultSlug+"#"+top5ProducerSourceRef}>{top5ProducerSourceRef}</a></small>
						: ""}
					</h3>
					<table style={{width:"100%", float:"left", marginBottom:"20px"}}>
						<thead>
							<tr>
								<th>Country</th>
								<th style={{width:"25%"}}>{top5ProducerUnit}</th>
							</tr>
						</thead>
						<tbody>
							<Top5ProducerExporterField top5Arr={{top5ProducerArr}} by="producer"/>
						</tbody>
					</table>
					{top5ProducerNotes  ? 
						<p className="notes-info" style={{marginTop: "auto", marginBottom: "20px"}}>
						<em>{top5ProducerNotes}</em>
						</p>
					: ""}
				</div>
				<div className="clearfix" style={{marginBottom: "20px"}}>
					<h3>
						Top 5 Exporting Countries of {foodName}
						{top5ExporterYear > 0 ? 
						<small>&nbsp;({top5ExporterYear})</small>
						: ""}
						{top5ExporterSourceRef && top5ExporterSourceRef > 0 ? 
						<small className="superscript"><a href={thisBaseURL +"/foods/" +defaultSlug+"#"+top5ExporterSourceRef}>{top5ExporterSourceRef}</a></small>
						: ""}
					</h3>
					<table style={{width:"100%", float:"left", marginBottom:"20px"}}>
						<thead>
							<tr>
								<th>Country</th>
								<th style={{width:"25%"}}>{top5ExporterUnit}</th>
							</tr>
						</thead>
						<tbody>
							<Top5ProducerExporterField top5Arr={{top5ExporterArr}} by="exporter"/>
						</tbody>
					</table>
					{top5ExporterNotes  ? 
						<p className="notes-info" style={{marginTop: "auto", marginBottom: "20px"}}>
						<em>{top5ExporterNotes}</em>
						</p>
					: ""}
				</div>
			</div>);
}
export default Top5ProducersExporters;